export default __webpack_public_path__ + "static/media/right-team.ed78623b.png";